function normalizeKey(keyString) {
    const enc = new TextEncoder();
    const bytes = enc.encode(keyString);

    // Garante 32 bytes (AES-256)
    const keyBytes = new Uint8Array(32);
    keyBytes.set(bytes.slice(0, 32)); // corta se for maior
    return keyBytes;
  }

export const decryptResponse = async (encryptedBase64, ivBase64, keyString) => {
    const keyBytes = normalizeKey(keyString);

    const aesKey = await crypto.subtle.importKey(
      "raw",
      keyBytes,
      { name: "AES-GCM" },
      false,
      ["decrypt"]
    );

    const cipherTag = Uint8Array.from(atob(encryptedBase64), c => c.charCodeAt(0));
    const iv = Uint8Array.from(atob(ivBase64), c => c.charCodeAt(0));

    const tagLength = 16;
    const ciphertext = cipherTag.slice(0, cipherTag.length - tagLength);
    const tag = cipherTag.slice(cipherTag.length - tagLength);
    const cipherWithTag = new Uint8Array([...ciphertext, ...tag]);

    const plainBuffer = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      aesKey,
      cipherWithTag
    );

    return new TextDecoder().decode(plainBuffer);
}

export function decryptXOR(base64Data, key) {
  const dataBytes = Uint8Array.from(atob(base64Data.replace(/\s+/g, "")), c => c.charCodeAt(0));
  const keyBytes = new TextEncoder().encode(key);
  const plainBytes = new Uint8Array(dataBytes.length);

  for (let i = 0; i < dataBytes.length; i++) {
    plainBytes[i] = dataBytes[i] ^ keyBytes[i % keyBytes.length];
  }

  return new TextDecoder("utf-8").decode(plainBytes);
}

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

export function reverseShift(shiftedStr, shift, alphabet = ALPHABET) {
  // Inverte a rotação
  const len = alphabet.length;
  const chars = shiftedStr.split("");
  for (let i = 0; i < chars.length; i++) {
    const c = chars[i];
    if (c === "=") continue; // padding
    const idx = alphabet.indexOf(c);
    if (idx >= 0) {
      let origIdx = (idx - shift) % len;
      if (origIdx < 0) origIdx += len;
      chars[i] = alphabet[origIdx];
    } else {
      // deixa como está se não pertence (não deve acontecer)
      chars[i] = c;
    }
  }
  return chars.join("");
}

export function decryptBase64Shift(shiftedBase64) {
  const b64 = reverseShift(shiftedBase64.replace(/\s+/g, ""), 5);
  // decodifica base64 para string UTF-8
  const bytes = Uint8Array.from(atob(b64), c => c.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}